import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RappiderMenuSideComponent } from './menu-side.component';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { RappiderTagModule } from '../tag/tag.module';
import { RappiderIconModule } from '../icon/icon.module';
import { NzMenuModule } from 'ng-zorro-antd/menu';

@NgModule({
  declarations: [
    RappiderMenuSideComponent
  ],
  imports: [
    CommonModule,
    NzDrawerModule,
    RappiderTagModule,
    RappiderIconModule,
    NzMenuModule
  ],
  exports: [
    RappiderMenuSideComponent
  ]
})
export class RappiderMenuSideModule { }
